import { LogIn } from "lucide-react";

export default function Login() {
  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-24 min-h-[70vh] flex items-center justify-center" data-testid="login-page">
      <div className="panel p-10 max-w-md w-full text-center">
        <div className="mono-caps mb-3">Giriş</div>
        <h1 className="font-display text-3xl font-bold text-white">Google ile devam et</h1>
        <p className="text-sm text-slate-400 mt-3">Siparişlerini takip etmek, dosyalarını yüklemek ve revizyon talep etmek için giriş yap.</p>
        <button onClick={startLogin} data-testid="google-login-btn"
          className="btn-cyan mt-8 inline-flex items-center gap-2 w-full justify-center">
          <LogIn className="w-4 h-4" /> Google ile Giriş Yap
        </button>
      </div>
    </main>
  );
}
